import React, { useState, Fragment } from "react";
import { useFormik } from "formik";
import { Button } from "primereact/button";
import { AutoComplete } from "primereact/autocomplete";
import { classNames } from "primereact/utils";


const EmailDialogForm = ({ save, onClose, userData, mailIdListprop, getUserEmail }) => {
  const [filteredUser, setFilteredUser] = useState(null);
  // const [selectedUser,setSelectedUser] = useState();
  const formik = useFormik({
    initialValues: {
      Email: null,
    },
    validate: (data) => {
      let errors = {};
      if (!data.Email) {
        errors.Email = "Email is required.";
      }
      return errors;
    },
    onSubmit: (data) => {
      save(data);
    },
  });

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  const sendEmail = () => {
    let emailIdList = [];
    formik.values.Email.map((el) => {
      emailIdList.push(el.email)
    })
    mailIdListprop(emailIdList)

  }
  const searchUser = (event) => {
    if (event.query.length === 2) {
      getUserEmail(event.query)
    }
    else {
      setTimeout(() => {
        let _filteredUsers;
        if (!event.query.trim().length) {
          _filteredUsers = [...userData];
        } else {
          _filteredUsers = userData.filter((p) => {
            return p.email.toLowerCase().startsWith(event.query.toLowerCase());
          });
        }
        setFilteredUser(_filteredUsers)
      }, 250);
    }

  };
  const onCloseMethod = () => {
    onClose();
  };
  const myForm = (
    <React.Fragment>
      <form
        onSubmit={formik.handleSubmit}
        className="p-fluid p-grid"
        autoComplete="off"
      >
        <Fragment>
          <span>Email:</span>
          <span className="p-fluid">
            <AutoComplete
              value={formik.values.Email}
              suggestions={filteredUser}
              completeMethod={searchUser}
              field="email"
              virtualScrollerOptions={{ itemSize: 38 }}
              name="Email"
              multiple
              onChange={formik.handleChange}
              placeholder="Enter Email"
              aria-label="email"
              dropdownAriaLabel="email"
              className={classNames({ 'p-invalid': isFormFieldValid('Email') })}
            />
            {getFormErrorMessage("Email")}
          </span>
        </Fragment>

        <div className="pt-3">
          <div className="grid" style={{ float: "right" }}>
            <div className='mr-2 mt-1'>
              <Button
                label="Cancel"
                type="button"
                className="p-button-rounded p-button-secondary"
                onClick={(e) => onCloseMethod(e)}
              />
            </div>
            <div className='mt-1'>
              <Button
                label="Send"
                type="submit"
                className="p-button-rounded"
                onClick={sendEmail}
              />
            </div>
          </div>
        </div>
      </form>
    </React.Fragment>
  );
  return <React.Fragment>{myForm}</React.Fragment>;
};

export default EmailDialogForm;